/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/
import { CoreCardReviewRendererType, CoreCustomCardType } from '../../../class/workflow.type';
import { workflowCardRegistry } from '../../shared/workflow-registries';

// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function CoreCustomCardReviewRenderer(reviewRendererType: CoreCardReviewRendererType) {
  return (target) => {
    if (!workflowCardRegistry[reviewRendererType]) {
      workflowCardRegistry[reviewRendererType] = target;
    }
  };
}

export const CoreCustomCard = (cardType: CoreCustomCardType) => (target) => CoreCustomBase(cardType, target);

/** Custom Card decorator */
// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function CoreCustomBase<T>(customCardType: CoreCustomCardType | T, target, registry: unknown = workflowCardRegistry) {
  const pageType = customCardType as string;

  if (!registry[pageType]) {
    registry[pageType] = target;
  }
}
